
export default {
  data () {
    return {
      defaultAttrs: {
        maxWidth: 1440,
        fluid: true
      }
    }
  }
}
